import { apiClient } from "services/api-client"

export const getProcesses = async (tenant) => {
  return await apiClient.get(`/mapping/process?companyKey=${tenant}`)
}

export const getProcessesPaged = async (tenant, page, perPage) => {
  return await apiClient.get(`/mapping/process/paged?companyKey=${tenant}&page=${page}&perPage=${perPage}`)
}

export const getProcessesShort = async (tenant) => {
  return await apiClient.get(`/mapping/process/short-data?companyKey=${tenant}`)
}

export const getProcessesShortPaged = async (tenant, page, perPage, queryContent) => {
  return await apiClient.get(`/mapping/process/short-data-paged?companyKey=${tenant}&page=${page}&perPage=${perPage}${queryContent}`)
}

export const getProcessesNames = async (tenant) => {
  return await apiClient.get(`/mapping/process/names?companyKey=${tenant}`)
}

export const getProcessById = async (id) => {
  return await apiClient.get(`/mapping/process/${id}`)
}

export const getProcessMappingByIdAndMappingId = async (id, processMappingId) => {
  return await apiClient.get(`/mapping/process/${id}/mapping/${processMappingId}`)
}

export const getProcessBoundsById = async (id) => {
  return await apiClient.get(`/mapping/process/${id}/bounds`)
}

export const addProcess = async (process) => {
  return await apiClient.post('/mapping/process', process)
}

export const editProcess = async (id, process) => {
  return await apiClient.put(`/mapping/process/${id}`, process)
}

export const addProcessDataMapping = async (id, processDataMapping) => {
  return await apiClient.post(`/mapping/process/${id}/mapping`, processDataMapping)
}

export const editProcessDataMapping = async (id, dataMappingId, processDataMapping) => {
  return await apiClient.put(`/mapping/process/${id}/mapping/${dataMappingId}`, processDataMapping)
}

export const importProcessDataMapping = async (id, content) => {
  return await apiClient.post(`/mapping/process/${id}/import-mapping`, content)
}

export const deleteProcess = async (processId) => {
  return await apiClient.delete(`/mapping/process/${processId}`)
}

export const deleteProcessMapping = async (processId, processMappingId) => {
  return await apiClient.delete(`/mapping/process/${processId}/mapping/${processMappingId}`)
}

export const archiveProcess = async (processId) => {
  return await apiClient.post(`/mapping/process/${processId}/archive`)
}
export const unarchiveProcess = async (processId) => {
  return await apiClient.post(`/mapping/process/${processId}/unarchive`)
}